import { IAppEntity } from "src/config/entities";
import React from "react";
import { ReferenceTypes } from "src/enums/ReferenceTypes";
import { PurchaseOrdersService } from "src/services/documents/PurchaseOrdersService";
import { DocumentPostStatusEnum } from "src/enums/DocumentPostStatusEnum";
import { TransferOfGoodsDetail } from "src/components/Pages/Documents/Warehouse/TransferOfGoods/components/TransferOfGoodsDetail";
import TransferOfGoodsList from "src/components/Pages/Documents/Warehouse/TransferOfGoods/components/TransferOfGoodsList";
import { NFLookupTransferOfGoods } from "src/components/Shared/NewForms/NFLookupTransferOfGoods";
import { TransferOfGoodsDto } from "src/components/Pages/Documents/Warehouse/TransferOfGoods/dtos/TransferOfGoodsDto";
import { TransferOfGoodsService } from "src/services/documents/TransferOfGoodsService";

export const TransferOfGoods: IAppEntity = {
  entityType: "document",
  title: "Transfer Of Goods",
  pluralTitle: "Transfer Of Goods",
  apiUrl: "TransferOfGoods",
  apiEnum: ReferenceTypes.DocumentTransferOfGoods,
  getDetailView: (id?: string) => {
    return React.createElement(TransferOfGoodsDetail, {
      id: id
    });
  },
  getDetailViewComponent: (model: any, modelUpdatedEvent: (model: any) => void) => React.createElement(React.Fragment, {}),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(TransferOfGoodsList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent
    }),

  getLookupComponent(model: any): any {
    return React.createElement(NFLookupTransferOfGoods, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog
    });
  },
  getDataService: () => new TransferOfGoodsService("TransferOfGoods"),
  getEmptyModel: () => {
    const model: TransferOfGoodsDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      status: DocumentPostStatusEnum.Draft,
      documentDate: new Date(),
      createdDate: new Date(),
      products: []
    };
    return model;
  }
};
